import jobfair1 from "../images/job_fair/jobfair1.png";
import '../invitations/Invitation.css'

const jobfairInvitationElements = [

  // 💼 TOP ICONS
  {
    id: 1,
    type: "text",
    text: "💼",
    x: 130,
    y: 320,
    fontSize: 25,
    fontFamily: "Poppins",
    fill: "#1d4ed8"
  },

  {
    id: 2,
    type: "text",
    text: "💼",
    x: 430,
    y: 320,
    fontSize: 25,
    fontFamily: "Poppins",
    fill: "#1d4ed8"
  },



  // 💼 TITLE
  {
    id: 4,
    type: "text",
    text: "JOB FAIR 2026",
    x: 200,
    y: 310,
    fontSize: 35,
    fontFamily: "Playfair Display",
    fill: "#390d3b"
  },

  // ✨ SUBTITLE
  {
    id: 5,
    type: "text",
    text: "You're Invited!",
    x: 220,
    y: 370,
    fontSize: 28,
    fontFamily: "Great Vibes",
    fill: "#390d3b"
  },

  // ✨ LINE
  {
    id: 6,
    type: "text",
    text: "──────── ✦ ────────",
    x: 230,
    y: 395,
    fontSize: 10,
    fontFamily: "Poppins",
    fill: "#390d3b"
  },

  // 🏢 EVENT NAME
  {
    id: 7,
    type: "text",
    text: "Mega Hiring Drive & Career Expo",
    x: 160,
    y: 420,
    fontSize: 18,
    fontFamily: "Poppins",
    fill: "#390d3b"
  },

  // 📢 DESCRIPTION
  {
    id: 8,
    type: "text",
    text: "Meet top recruiters and explore exciting",
    x: 160,
    y: 450,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#390d3b"
  },

  {
    id: 9,
    type: "text",
    text: "career opportunities across multiple industries.",
    x: 130,
    y: 475,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#390d3b"
  },

  {
    id: 18,
    type: "text",
    text: "Bring your resume & get hired on the spot!",
    x: 150,
    y: 500,
    fontSize: 14,
    fontFamily: "Poppins",
    fill: "#4b3e08"
  },

  // 📅 DATE
  {
    id: 10,
    type: "text",
    text: "🗓 Sunday, 22 March 2026",
    x: 200,
    y: 530,
    fontSize: 17,
    fontFamily: "Poppins",
    fill: "#050506"
  },

  // ⏰ TIME
  {
    id: 11,
    type: "text",
    text: "⏱ 9:00 AM – 4:00 PM",
    x: 200,
    y: 560,
    fontSize: 17,
    fontFamily: "Poppins",
    fill: "#050506"
  },

  // 📍 VENUE TITLE
  {
    id: 12,
    type: "text",
    text: "Venue",
    x: 250,
    y: 590,
    fontSize: 20,
    fontFamily: "Playfair Display",
    fill: "#4b3e08"
  },

  // 📍 VENUE NAME
  {
    id: 13,
    type: "text",
    text: "Convention Hall,",
    x: 210,
    y: 620,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#334155"
  },

  {
    id: 14,
    type: "text",
    text: "Vijayawada",
    x: 240,
    y: 650,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#334155"
  },

  // 📞 CONTACT
  {
    id: 15,
    type: "text",
    text: "📞 Contact: 98765XXXXX",
    x: 200,
    y: 700,
    fontSize: 16,
    fontFamily: "Poppins",
    fill: "#1a1a1a"
  },

  // 🎯 FINAL LINE
  {
    id: 16,
    type: "text",
    text: "Start Your Career Journey With Us!",
    x: 170,
    y: 750,
    fontSize: 18,
    fontFamily: "Playfair Display",
    fill: "#4b3e08"
  },

  // BACKGROUND IMAGE
  {
    id: 17,
    type: "background",
    src: jobfair1,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  }

];

export default jobfairInvitationElements;